import {
  StepConnector as MuiStepConnector,
  type StepConnectorProps as MuiStepConnectorProps,
} from '@mui/material';

export type StepConnectorProps = MuiStepConnectorProps;

export const StepConnector = MuiStepConnector;
